import {formateData, headers} from "./index";

export const getMyWeiboList = (mediaCode, type, queryStr, start, size, callBack)=> {
    let url = "/cm-sites-pms/weibo/getMyStory";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({currentMedia:mediaCode,type,queryStr,start,size})
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getMyWeiboList",error);
        callBack([]);
    })
};

export const getAllWeiboList = (mediaCode, type, queryStr, start, size, callBack)=> {
    let url = "/cm-sites-pms/weibo/getAllStory";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({currentMedia:mediaCode,type,queryStr,start,size})
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getAllWeiboList",error);
        callBack([]);
    })
};